import PropTypes from 'prop-types';
import { useCallback } from 'react';
import moment from 'moment';
import { Button, Modal, Spin } from "antd"
import { useDictionaryTranslation } from "../../../../hooks/useDictionaryTranslation";
import { useServiceData } from "../../../Calendar/hooks/useServiceData";
import { FormWrapper } from '../../../../components/formWrapper/form-wrapper';
import { FormEditSupportService } from '../forms/FormEditSupportService';


export const ModalEditSupportService = ({
  show,
  handleClose,
  serviceId,
  defaultData,
  newData,
}) => {
  const { translate: t } = useDictionaryTranslation();
  const { serviceData, updateService, isLoading } = useServiceData({
    serviceId,
    defaultData,
    newData,
  });

  const closeModal = useCallback(
    (refreshData = false) => {
      handleClose(refreshData);
    },
    [handleClose],
  );

  const handleSubmit = async (formValues) => {
    const originalDate = serviceData?.start ? moment(serviceData.start) : null;
    const formStart = moment(`${formValues.serviceDate} ${formValues.serviceTime}`, 'YYYY-MM-DD HH:mm');
    const startChanged = !originalDate || !formStart.isSame(originalDate, 'minute');

    const dataToSend = {
      name: formValues.serviceName,
      idHeadquarter: formValues.headquarter?._id ?? null,
      idTypeService: formValues.serviceType ? formValues.serviceType._id : serviceData?.idTypeService?._id ?? null,
      ...(startChanged && { start: formStart.toDate().toISOString() }),
      idAssignedCompany: formValues.assignedCompany ? formValues.assignedCompany._id : null,
      idContactWhoCalls: formValues.selectedContact ? formValues.selectedContact._id : null,
      title: formValues.serviceDescription,
    };
    await updateService({
      ...dataToSend,
      newServiceId: serviceId,
      showMessage: true,
    });
    closeModal(true);
  };

  return (
    <Modal
      width="50%"
      destroyOnClose
      title={t('editService')}
      centered
      onCancel={closeModal}
      open={show}
      footer={
        <div>
          <Button form="editSupportService" key="submit" htmlType="submit" type="primary" disabled={isLoading}>
            {t('save')}
          </Button>
        </div>
      }
    >
      <Spin spinning={isLoading}>
        <FormWrapper>
          <FormEditSupportService
            key={serviceId && !serviceData ? '1' : '2'}
            formName="editSupportService"
            serviceData={serviceData}
            handleSubmit={handleSubmit}
          />
        </FormWrapper>
      </Spin>
    </Modal>
  )

}

ModalEditSupportService.propTypes = {
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  serviceId: PropTypes.string,
  defaultData: PropTypes.shape({
    start: PropTypes.string,
    headquarter: PropTypes.object,
    serviceType: PropTypes.object,
    professional: PropTypes.object,
  }),
  newData: PropTypes.shape({
    start: PropTypes.instanceOf(Date),
    headquarter: PropTypes.object,
    serviceType: PropTypes.object,
    professional: PropTypes.object,
  }),
};